<template>
  <div class="h-100" v-show="isShow">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'TabPane',
  props: {
    name: { type: String }
  },
  data() {
    return {
      isShow: false
    }
  }
}
</script>
